import { components } from "@/api-schema";
import { MergeSelection } from "@/api-schema-enums";

type MergeFieldPreview = components["schemas"]["MergeFieldPreviewResponse"];
type MergeSelections = components["schemas"]["MergeExecuteBody"]["selections"];
export type MergeEntityRef = components["schemas"]["MergeEntitySummaryResponse"];

export const buildDefaultChoices = (fields: MergeFieldPreview[]): MergeSelections => {
  const choices: MergeSelections = {};

  for (const field of fields) {
    const targetEmpty = field.targetValue == null || field.targetValue === "";
    const sourceHasValue = field.sourceValue != null && field.sourceValue !== "";
    choices[field.key] = targetEmpty && sourceHasValue ? MergeSelection.Source : MergeSelection.Target;
  }

  return choices;
};
